/* eslint-disable */
/* eslint-disable prefer-template */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { VBox } from '../../../components/Box';
import { Modal } from '../../../components/Modal';
import { VehicleSelectionModalButton } from '../../Vehicles/components/VehicleSelectionModalButton';

import ModalComponent from '../../../containers/App/Components/Modal/Modal';

const Container = styled.div``;

const STATE = {
  vehicle: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleActionActivatorComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    this.props.fetch();
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    return (
      <Container>
        {this.state.vehicle ? (
          this.renderAction()
        ) : (
          <VehicleSelectionModalButton onSelect={vehicle => this.setState({ vehicle })} />
        )}
      </Container>
    );
  }

  renderAction() {
    let Class = this.props.actionClass;
    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('vehicle.search.placeholder')}>
        <Class
          column={this.props.column}
          cell={{
            vehicle: this.state.vehicle,
          }}
          board_id={this.props.board_id}
          action={this.props.action}
          loggedUserId={this.props.loggedUserId}
          payload={this.props.payload}
          onChange={this.props.onChange}
        />
      </ModalComponent>
    );
  }
}

VehicleActionActivatorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {},
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleActionActivator = compose(withConnect, withRouter)(VehicleActionActivatorComp);
